import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccess = store.getters['identity/hasAccess']

export default [
  // Land Measurement Home Page
  {
    path: '/land-measurement/',
    name: 'Land Measurement',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccess([
          'i1a-landmeasurement:read',
          'i1a-landmeasurement:create',
          'i1a-landmeasurement:update',
          'i1a-landmeasurement:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/land-measurement'),
  },
  // Land Measurement Create
  {
    path: '/land-measurement/create',
    name: 'Land Measurement Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccess(['i1a-landmeasurement:create'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/land-measurement/form'),
  },
  // Land Measurement View
  {
    path: '/land-measurement/view/:id?',
    name: 'Land Measurement View',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccess(['i1a-landmeasurement:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/land-measurement/form'),
  },
]
